import React from 'react';

import { css, keyframes } from 'styled-components';

const keyframe = keyframes` {
  0% {
      stroke-dashoffset: 141.4%;
  }
  50% {
    stroke-dashoffset: 282.8%;
  }

  100% {
    stroke-dashoffset: 424.2%;
  }
}`;

const LoadingLine = ({ height = 2 }) => {
  return (
    <div
      css={css`
        height: 15px;
        margin-top: -14px;
        .loading line {
          stroke: ${({ theme: { colors } }) => colors.primary.primary};
          stroke-width: 6;
          stroke-dasharray: 141.4%;
          stroke-dashoffset: 141.4%;
          order: 1;
          animation: ${keyframe} 1s 0s infinite;
        }
      `}
    >
      <svg className="loading" height={height} width="100%">
        <line x1="0" y1="0" x2="100%" y2="0" />
      </svg>
    </div>
  );
};

export default LoadingLine;
